// src/pages/Contact.js
import React from 'react';
import RapidLogo from '../assets/rapid.png';

const Contact = () => {
    return (
        <div className="text-gray-200">
            {/* Header Section with Logo */}
            <section className="flex flex-col items-center text-center py-6 px-4 sm:px-8 space-y-3">
                <img src={RapidLogo} alt="Rapid Logo" className="w-16 h-auto mb-3" />
                <h1 className="text-2xl sm:text-3xl font-bold text-white">Contact Us</h1>
                <p className="text-gray-400 max-w-md text-sm sm:text-base mb-4">
                    Have questions or need more information? Reach out using the form below, and we’ll get back to you as soon as possible.
                </p>
            </section>

            {/* Contact Form Section */}
            <section className="bg-black border border-white p-5 sm:p-6 rounded-lg shadow-lg max-w-md mx-auto mb-6">
                <form className="flex flex-col space-y-6">
                    <div className="relative">
                        <label className="block text-sm font-medium text-gray-300 mb-1">Name</label>
                        <input
                            type="text"
                            required
                            placeholder="Your Name"
                            className="w-full bg-transparent text-gray-200 border-b border-gray-700 focus:border-white outline-none focus:ring-0 transition duration-200 placeholder-gray-500"
                        />
                    </div>
                    <div className="relative">
                        <label className="block text-sm font-medium text-gray-300 mb-1">Email</label>
                        <input
                            type="email"
                            required
                            placeholder="Your Email"
                            className="w-full bg-transparent text-gray-200 border-b border-gray-700 focus:border-white outline-none focus:ring-0 transition duration-200 placeholder-gray-500"
                        />
                    </div>
                    <div className="relative">
                        <label className="block text-sm font-medium text-gray-300 mb-1">Message</label>
                        <textarea
                            required
                            placeholder="Your Message"
                            rows="4"
                            className="w-full bg-transparent text-gray-200 border-b border-gray-700 focus:border-white outline-none focus:ring-0 transition duration-200 placeholder-gray-500"
                        ></textarea>
                    </div>
                    <button
                        type="submit"
                        className="w-full p-2 bg-white text-black font-semibold rounded-md hover:bg-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-white text-center uppercase"
                    >
                        Send Message
                    </button>
                </form>
            </section>
        </div>
    );
};

export default Contact;
